export function flattenToLokiFields(
	data: Record<string, string | number | boolean | null | undefined>,
): Record<string, string> {
	return Object.fromEntries(
		Object.entries(data).map(([k, v]) => [
			k,
			v === null || v === undefined ? '' : String(v),
		]),
	);
}

export function stringifyUnknownError(err: unknown): string {
	if (err instanceof Error) return err.message;
	if (typeof err === 'string') return err;
	try {
		return JSON.stringify(err);
	} catch {
		return String(err);
	}
}
